import { render, staticRenderFns } from "./VoiceMail.vue?vue&type=template&id=e65d0e98&"
import script from "./VoiceMail.vue?vue&type=script&lang=js&"
export * from "./VoiceMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports